import ModalController from "./modal_controller";

export default class extends ModalController {
  static targets = ["addInstallationGroup", 'groupNameBlock', "groupName", "groupSelect", "groupId", 'primaryGroup'];

  connect() {
    super.connect();
    document.addEventListener("autocomplete.change", this.changeGroup.bind(this));
  }

  disconnect() {
    document.removeEventListener("autocomplete.change", this.changeGroup.bind(this));
    super.disconnect();
  }

  changeGroup(event) {
    if (!this.hasGroupIdTarget) { return }

    if (event.detail && event.detail.value != "") {
      this.groupIdTarget.value = event.detail.value;
    }
  }

  showAddInstallationGroup(event) {
    super.show(event);

    this.stimulate("InstallationGroupReflex#show_add_installation_group", event.target);
  }

  submitInstallationGroupForm(event) {
    event.preventDefault();

    let form = event.srcElement.closest("form");
    let spinnerDiv = form.querySelector("#spinner");

    const createNew = form.querySelector('#create_new_group').checked;
    const groupName = this.groupNameTarget.value;
    const groupId = this.hasGroupIdTarget ? this.groupIdTarget.value : '';

    // Validace
    if (!createNew && (!groupId || groupId.trim() === '')) {
      alert('Please select a group');
      return;
    }

    if (createNew && (!groupName || groupName.trim() === '')) {
      alert('Please enter a group name');
      return;
    }

    this.spinnerOn(spinnerDiv);

    this.stimulate("InstallationGroupReflex#submit_installation_group_form", event.target).then((_payload) => {
      this.spinnerOff(spinnerDiv);
      this.closeModal();
    });
  }

  removeInstallationGroup(event) {
    this.stimulate("InstallationGroupReflex#remove_installation_group", event.target);
  }

  markAsPrimary(event) {
    this.stimulate("InstallationGroupReflex#mark_as_primary", event.target);
  }

  toggleGroupName(event) {
    const createNew = event.target.checked;

    if (createNew) {
      if (this.hasGroupSelectTarget) {
        this.groupSelectTarget.classList.add('hidden');
      }
      this.groupNameBlockTarget.classList.remove('hidden');
      // Clear autocomplete selection when creating new
      if (this.hasGroupIdTarget) {
        this.groupIdTarget.value = '';
      }
    } else {
      if (this.hasGroupSelectTarget) {
        this.groupSelectTarget.classList.remove('hidden');
      }
      this.groupNameBlockTarget.classList.add('hidden');
    }
  }
}
